import React from "react"
import DebugView, { boolVal, busyVal, DebugViewProps, useDebugLogs } from "../embed/components/DebugView"
import { useRaffle } from "./RaffleContext"
import { useRaffleErrorMsg } from "."

const RaffleDebugView: React.FC<{
  additionalActions?: DebugViewProps["actions"],
  additionalState?: DebugViewProps["state"],
  logs?: DebugViewProps["logs"],
}> = ({ additionalActions, additionalState, logs: additionalLogs }) => {
  const { logs } = useDebugLogs()
  const {
    raffle,
    busy,
    disableParticipateButton,
    wasAlreadyParticipatingOnFirstLoad,
    actionGetRaffle,
    actionParticipate,
  } = useRaffle()
  const raffleError = useRaffleErrorMsg()
  
  return <DebugView
    name="Raffle"
    actions={[
      ["getRaffle()", actionGetRaffle],
      ["participate()", actionParticipate],
      ...(additionalActions || []),
    ]}
    state={[
      ["raffle", raffle ? raffle.meta.title : "-"],
      ["busy", busyVal(busy)],
      ["disableParticipateButton", boolVal(disableParticipateButton)],
      ["participation", raffle ? boolVal(raffle.participation?.type === "participating") : "?"],
      ["wasAlreadyParticipatingOnFirstLoad", boolVal(wasAlreadyParticipatingOnFirstLoad)],
      ["error", raffleError ?? "-"],
      ...(additionalState ?? []),
    ]}
    logs={[...(logs || []), ...(additionalLogs || [])]}
    />
}

export default RaffleDebugView
